export const monitorAtHomeStatus = {
  title: "Monitoring at Home Status",
  not_invited: "Not Invited",
  invited: "Invited",
  locked: "Locked",
  accepted: "Accepted"
};
